import React from 'react';
import { Entypo } from '@expo/vector-icons';

export const BackIcon = ({ tintColor, size }: { tintColor: string, size?: number }) => {
  const SIZE = size?size:30;
  return <Entypo name="chevron-small-left" color={tintColor} size={SIZE}  />;
};
